"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nullOr = nullOr;
exports.default = void 0;

var _iterable = require("../../internal/iterable");

var _prepend = _interopRequireDefault(require("../$prepend/prepend"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function nullOr(source) {
  const iter = (0, _iterable.ensureIterable)(source)[Symbol.iterator]();
  const {
    done,
    value: first
  } = iter.next();
  return done ? null : (0, _prepend.default)(first, iter);
}

var _default = nullOr;
exports.default = _default;